import { styled } from '@mui/material/styles'
import LinearProgress from '@mui/material/LinearProgress'

const EnekaLinearProgress = styled(LinearProgress)(() => ({
  backgroundColor: '#bfbfbf',
  '& .MuiLinearProgress-bar': {
    backgroundColor: '#00AEA6'
  }
}))

export default EnekaLinearProgress
